export default {
  en: {
    /*   plusCards: [
      {
        title: 'Your Business Solution',
        description: 'Run your business — even when you are away. Instantly confirm appointments and directly message clients, all from the comfort of your smart device. Work with a dedicated advisor to help answer any questions or get advice on marketing and promotions.',
        icon: require('ui/staticSiteData/premiumAccountDescriptionData/images/icon1.svg'),
      },
      {
        title: 'Know Your Clients, Before the First Visit',
        description: 'Access our secure database to review client and pet profiles. With our online messaging portal, you can ask questions before the initial visit, letting you save time and offer personalized care — every time.',
        icon: require('ui/staticSiteData/premiumAccountDescriptionData/images/icon2.svg'),
      },
      {
        title: 'Personalized Support',
        description: 'We want your business to grow, and we can help you do it. Our specialists handle the initial setup and onboarding, answer questions, and help you customize your online business. We ensure you have everything you need to thrive.',
        icon: require('ui/staticSiteData/premiumAccountDescriptionData/images/icon3.svg'),
      },
    ],*/
    monthPriceData: {
      per: 'month',
      title: 'Monthly',
      price: '$19.99',
      oldPrice: null,
      pluses: [
        'Sign up today, cancel any time',
        'Instant appointment confirmation',
        'Dedicated Business Advisor',
        'Direct messaging to clients',
        'Personalized Page Consultation',
      ],
    },
    yearPriceData: {
      per: 'year',
      title: 'Yearly',
      price: '$199.99',
      oldPrice: '$239.88',
      pluses: [
        'Sign up today, cancel any time',
        'Instant appointment confirmation',
        'Dedicated Business Advisor',
        'Direct messaging to clients',
        'Personalized Page Consultation',
      ],
    },
  },
};
